<template>
  <div v-if="data && data.items" :id="id" :class="className" :style="{ height: height, width: width }" />
  <div v-else :style="{ height: height, width: width, lineHeight: height }" style="text-align: center;color: #909399;font-size:0.8rem;">暂无数据</div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    range: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      chart: null,
      showLabel: []
    }
  },
  watch: {
    data() {
      this.buildData()
    }
  },
  mounted() {
    this.buildData()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    // 生成数据
    buildData() {
      var that = this
      if (!that.data || !that.data.items) {
        return
      }
      var doneValue1 = that.data.items[0].points
      var doneValue2 = that.data.items[1].points
      var doneValue3 = that.data.items[2].points
      var doneValue4 = that.data.items[3].points
      // console.log('1', doneValue1)
      // console.log('2', doneValue2)
      // console.log('3', doneValue3)
      // console.log('3', doneValue4)

      var columLabel = ['GET', 'POST', '总请求', '错误']
      // var curColumName = that.getTimeList(that.data.time_begin, that.data.time_end)
      that.getTimeList(that.data.time_begin, that.data.time_end)
      var columName = that.showLabel
      var columnValue = []
      var arrData = []
      for (var i = 0; i < columLabel.length; i++) {
        arrData = []
        for (var j = 0; j < columName.length; j++) {
          if (i === 0) {
            arrData.push(doneValue1[j] ? doneValue1[j] : 0)
          } else if (i === 1) {
            arrData.push(doneValue2[j] ? doneValue2[j] : 0)
          } else if (i === 2) {
            arrData.push(doneValue3[j] ? doneValue3[j] : 0)
          } else {
            arrData.push(doneValue4[j] ? doneValue4[j] : 0)
          }
        }
        // eslint-disable-next-line no-eval
        columnValue.push(eval('(' + ("{'name':'" + columLabel[i] + "','type':'line','smooth': true,'symbol':'none','itemStyle': {normal: {lineStyle: {width:2}},emphasis: {lineStyle: {width:2}}},'data':[" + arrData + ']}') + ')'))
      }

      that.$nextTick(function() {
        that.buildChart(columLabel, columName, columnValue)
      })
    },
    // 生成图形
    buildChart(columLabel, columName, columnValue) {
      var that = this
      if (that.chart) {
        that.chart.dispose()// 销毁
      }
      that.chart = echarts.init(document.getElementById(that.id))

      var option = {
        // color: ['#68E6C1', '#fac858'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
          orient: 'horizontal',
          // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
          x: 'left',
          // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
          y: 'top',
          icon: 'rect', // 形状  类型包括 circle，rect,line，roundRect，triangle，diamond，pin，arrow，none
          itemWidth: 12, // 设置宽度
          itemHeight: 12, // 设置高度
          itemGap: 20, // 设置间距
          data: columLabel
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: {
          min: 0,
          type: 'category',
          data: columName
        },
        yAxis: {
          min: 0,
          minInterval: 1,
          type: 'value'
          // ,
          // max: this.getMaxVal()
        },
        dataZoom: [{
          type: 'inside',
          start: 90,
          end: 100
        }],
        series: columnValue
      }

      that.chart.setOption(option)
    },
    getMaxVal() {
      var that = this
      var maxVal = 0
      if (that.data.maxValue) {
        maxVal = that.data.maxValue
      }
      maxVal += 1
      // 如果是单数
      if (maxVal % 2 !== 0) {
        maxVal += 1
      }
      if (maxVal < 4) {
        maxVal = 4
      }
      return maxVal
    },
    getTimeList(start, end) {
      var that = this
      if (!start || !end) {
        return
      }
      that.showLabel = []
      var format2 = 'MM-DD HH:mm'
      var startTime = that.$moment(start)
      var endTime = that.$moment(end)
      startTime = that.$moment(startTime).add(that.range, 'minutes');
      while (that.$moment(startTime).valueOf() <= that.$moment(endTime).valueOf()) {
        that.showLabel.push(that.$moment(startTime).format(format2))
        startTime = that.$moment(startTime).add(that.range, 'minutes');
      }
      return
    }
  }
}
</script>
